import React from 'react';
import { Modal, CloseWrapper, Button } from '@tcc/crate';

import { getMessage } from '@tcc/i18n';
import styles from './FhaErrorModal.css';
import { redirectWithClientId } from '../../utils/url';
import { BASE_FIELDS_URL, BASE_FIELDS_URL_NEW_ARCH } from '../../constants/urls';

function FhaErrorModal({ newArchFlagFieldSelection }) {
  const redirectLink = newArchFlagFieldSelection 
    ? BASE_FIELDS_URL_NEW_ARCH 
    : BASE_FIELDS_URL;
  return (
    <CloseWrapper onRootClose={() => redirectWithClientId(redirectLink)}>
      <Modal
        className={`${styles.errorModal}`}
        data-test-id="FHAerrorModal"
        role="dialog"
        show
      >
        <div className={`${styles.errorTitle}`}>
          {getMessage('FhaError.title')}
        </div>
        <div className={`${styles.errorMessage}`}>
          {getMessage('FhaError.text')}
        </div>
        <Button
          className={`${styles.errorButton}`}
          data-test-id="fhaErrorModal-button"
          mode="primary"
          onClick={(e) => {
            e?.stopPropagation();
            redirectWithClientId(redirectLink);
          }}
        >
          {getMessage('FhaError.button')}
        </Button>
      </Modal>
    </CloseWrapper>
  );
}

export default FhaErrorModal;
